'use strict';
import {runInjector} from '../_libs/angular-utils/index';
import {TaskAssignmentComponent} from './components/TaskAssignment/TaskAssignmentComponent';
import {TaskAssignmentButtonComponent} from './components/TaskAssignmentButton/TaskAssignmentButtonComponent';
import {TaskDetailsNavContainer} from './components/TaskDetailsNavContainer';
import {injector as TaskItemContainerInjector} from './components/TaskItem/TaskItemContainer';
import {AssetTaskViewActivity, ProjectTaskViewActivity, TemplateTaskViewActivity} from './components/TaskViewActivity';
import {
  AssetTaskViewRequirements,
  ProjectTaskViewRequirements,
  TemplateTaskViewRequirements,
} from './components/TaskViewRequirements';
import {AssetTaskViewTimerLog, ProjectTaskViewTimerLog} from './components/TaskViewTimerLog';
import {TaskScheduleDialogController} from './controllers/TaskScheduleDialogController';
import {TasksCreateController} from './controllers/TasksCreateController';
import {TasksDetailsController} from './controllers/TasksDetailsController';
import {TasksListController} from './controllers/TasksListController';
import {AbstractTaskProvider} from './domain/$$AbstractTask';
import {AssetTaskDomainProvider} from './domain/AssetTaskDomain';
import {TaskApprovalDomainProvider} from './domain/TaskApprovalDomain';
import {TaskDependencyDomainProvider} from './domain/TaskDependencyDomain';
import {TaskDomainProvider} from './domain/TaskDomain';
import {TasksFilterService} from './filters/TasksFilterService';
import {routerAssetTasksProvider} from './router-asset-tasks';
import {routerTemplateTasksProvider} from './router-project-asset-tasks';
import {routerProjectsTasksProvider} from './router-project-tasks';
import {FilesDownloadService} from './services/FilesDownloadService';
import {taskCreateModals} from './services/taskCreateModals';
import {TaskMetricsService} from './services/TaskMetricsService';


const angular = require('angular');

module.exports = angular
  .module('app.tasks', [])
  .constant('TASK_STATE_HELPER', require('./TASK_STATE_HELPER.js'))

  .constant('AssetTaskViewActivity', AssetTaskViewActivity)
  .constant('ProjectTaskViewActivity', ProjectTaskViewActivity)
  .constant('TemplateTaskViewActivity', TemplateTaskViewActivity)

  .constant('AssetTaskViewRequirements', AssetTaskViewRequirements)
  .constant('ProjectTaskViewRequirements', ProjectTaskViewRequirements)
  .constant('TemplateTaskViewRequirements', TemplateTaskViewRequirements)

  .constant('AssetTaskViewTimerLog', AssetTaskViewTimerLog)
  .constant('ProjectTaskViewTimerLog', ProjectTaskViewTimerLog)

  .config(routerAssetTasksProvider)
  .config(routerTemplateTasksProvider)
  .config(routerProjectsTasksProvider)

  .run(require('./filters/templates.js'))
  .run(runInjector(TaskAssignmentComponent))
  .run(runInjector(TaskAssignmentButtonComponent))
  .run(runInjector(TaskDetailsNavContainer))
  .run(TaskItemContainerInjector)

  .provider('$$AbstractTask', AbstractTaskProvider)
  .provider('AssetTaskDomain', AssetTaskDomainProvider)
  .provider('TaskApprovalDomain', TaskApprovalDomainProvider)
  .provider('TaskDependencyDomain', TaskDependencyDomainProvider)
  .provider('TaskDomain', TaskDomainProvider)

  .service('FilesDownloadService', FilesDownloadService)
  .service('taskCreateModals', taskCreateModals)
  .service('TaskMetricsService', TaskMetricsService)

  .service('TasksFilterService', TasksFilterService)

  .controller('TaskScheduleDialogController', TaskScheduleDialogController)
  .controller('TasksCreateController', TasksCreateController)
  .controller('TasksDetailsController', TasksDetailsController)
  .controller('TasksListController', TasksListController)
;



// WEBPACK FOOTER //
// ./src/js/tasks/index.js